import React from 'react';
import { environment } from '_environments'
import { apiStates, useApi } from '_hooks'
import { FoodsPage } from '_scenes'
import { FoodType } from '_types'

export const useFoods = () => {
	document.body.classList.add('foodsPage');
	const { state, error, data } = useApi(environment.backend.api + '/food');

	switch (state) {
		case apiStates.ERROR:
			return <p>ERROR: {error || 'General error'}</p>;
		case apiStates.SUCCESS:
			const foods: FoodType[] = data;
			return (
				<FoodsPage foods={foods} />
			);
		default:
			return <p>loading..</p>;
	}
};